import angular from "angular";
//import AuthenticationService from "./AuthenticationService";
import ConfigService from "app/services/ConfigService";
import lodash from "app/services/lodash";

export default angular.module("services.FeatureService", [ConfigService, lodash]).factory("FeatureService",
  ["ConfigService", "_", "$log", "$q",
    function FeatureService(ConfigService, _, $log, $q) {
      var hasDemoFeature;

      var features = [];
      var useGloballyDisabledFeatures = true;

      function hasDemoUserFeature() {
        var isDemoUser = hasFeatureInHash("demoUser");
        setDemoUserFeature(isDemoUser);
        return $q.when(isDemoUser);
        /*var defer = $q.defer();
        if ((hasDemoFeature === undefined) || (AuthenticationService.getResetFeature())) {
          hasFeature("demoUser").then(function (isDemoUser) {
            setDemoUserFeature(isDemoUser);
            AuthenticationService.setResetFeature(false);
            defer.resolve(isDemoUser);
          });
        } else {
          defer.resolve(hasDemoFeature);
        }
        return defer.promise;*/
      }

      function setDemoUserFeature(value) {
        hasDemoFeature = value;
      }

      function hasFeatureInHash(key) {
        let filtered = [];
        if (key) {
          if (_.isArray(key)) {
            return (_.intersection(key, features).length > 0) && !globallyDisabled(key);
          } else {
            filtered = _.filter(features, feature => feature.toLowerCase() === key.toLowerCase());
            return filtered.length > 0 && !globallyDisabled(key);
          }
        } else {
          return true;
        }
      }

      function hasFeature(key) {
        //var defer = $q.defer();
        return $q.when(hasFeatureInHash(key));
      }

      function setFeatures(_features) {
        features = _features;
      }

      function globallyDisabled(key) {
        return !useGloballyDisabledFeatures ? false : (ConfigService.get("globallyDisabledFeatures", true) || []).indexOf(key) >= 0;
      }

      function setUseGloballyDisabledFeatures(value) {
        useGloballyDisabledFeatures = value;
      }

      return {
        hasFeatureInHash: hasFeatureInHash,
        hasFeature: hasFeature,
        hasDemoUserFeature: hasDemoUserFeature,
        setDemoUserFeature: setDemoUserFeature,
        setFeatures: setFeatures,
        setUseGloballyDisabledFeatures: setUseGloballyDisabledFeatures
      };

    }]).name;



// WEBPACK FOOTER //
// ./src/ui/modules/dcb-eaccount/services/FeatureService.js